export default {
  getHubSpotCompany: (state) => state.hubSpotCompany,
};
